import mapFunction from './mapResources';

export default mapFunction('store_content', {
    isFetching: false,
    items: [] 
});